import React from 'react';
import * as styles from './base.scss';
const HideOnDesktop = (props) => {
    return (React.createElement("div", { className: styles.container }, props.children));
};
export default (HideOnDesktop);
